import { render, staticRenderFns } from "./SiteAbout2.vue?vue&type=template&id=096bb605&scoped=true"
var script = {}
import style0 from "./SiteAbout2.vue?vue&type=style&index=0&id=096bb605&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096bb605",
  null
  
)

export default component.exports